<template>
  <div>
    <div v-if="optionTokenStr!==''">
      <div  class="form-check" v-for="(item,index) in options" :key="index">
        <input class="form-check-input" :name="'rg1'+controlId" type="radio" :id="'r1'+controlId" :value="item" v-model="propsValue">
        <label class="form-check-label" :for="'r1'+controlId">
          {{ item }}
        </label>
      </div>

      <div v-if="!existItem()">
        使用者填寫了不正確的選項:{{propsValue}}
        請修正
      </div>

    </div>
    <div v-if="optionTokenStr===''">
      <input type="text" class="form-control"  placeholder="" v-model="propsValue">
    </div>





  </div>
</template>

<script>
/**

 <MyRadioWithTokenStr v-model="item.Question1Answer" :option-token-str="item.Question1Options" token-str=","></MyRadioWithTokenStr>
 **/


export default {
  props: {
    optionTokenStr: {
      type: String,
      default() {
        return "";
      }
    },
    TokenStr: {
      type: String,
      default() {
        return ",";
      }
    },
    value: {
      type: String,
      default() {
        return "";
      }
    },
  },
  data: function () {
    return {
      id: "",
      dataReady: false,
      propsValue: this.value,
      formData: {
        name: "",
      },
      controlId:"",
    };
  },
  computed: {
    options(){
      if (this.optionTokenStr===""){
        return [];
      }
      return this.optionTokenStr.split(this.TokenStr);
    },
  },
  watch: {
    propsValue(newVal) {
      this.$emit('input', newVal);
    },
    value(newVal) {
      this.propsValue = newVal
    }
  },
  methods: {
    existItem(){
      let items=this.options.filter(s=>s===this.propsValue);

      if (items.length===0 && this.propsValue!==""){
        return false;
      }else{
        return true;
      }
    },
    //給予value屬性預設值
    initValue() {
      const isMyObjectEmpty = !Object.keys(this.value).length;

      if (isMyObjectEmpty) {
        let template = {...this.datasDemo};
        this.value = template;
      }
    },
    async loadData() {
      // let data=await apiUtil.api_SupplierTODO("12138114-01")

      // this.data=data
    },
  },
  mounted() {
    this.controlId=this._uid;
    // this.initValue()
    //this.loadData()
  },
}
</script>

<style scoped>

</style>
